import { MatTableDataSource, MatTable } from '@angular/material/table';
import { ViewChild, Component, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConfirmationComponent } from 'src/app/shared/components/confirmation/confirmation.component';
import { RepReportService } from 'src/app/appReport/services/repReport.service';
import { FieldModal } from 'src/app/appReport/modals/field/field.modal';
import { FilterModal } from 'src/app/appReport/modals/filter/filter.modal';
import { MatSort } from '@angular/material/sort';
import { CountryReportModal } from 'src/app/appReport/modals/country/countryReport.modal';
import { ReportEditComponent } from 'src/app/appReport/modals/reportEdit/reportEdit.component';

@Component({
    selector: 'app-repReportList',
    templateUrl: './repReportList.component.html',
    styleUrls: ['./repReportList.component.css']
})
export class RepReportListComponent implements OnInit {
    nameApp:String;
    loading: boolean;
    columns: string[];
    dataSource = new MatTableDataSource<any>();
    @ViewChild(MatTable) table: MatTable<any>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(private repReportS: RepReportService, private dialog: MatDialog, private alertS: AlertService) {
        this.nameApp = 'REPORTES';
        this.loading = false;
        this.columns = ['name', 'storeProcedure', 'section', 'active', 'Acciones'];
        this.dataSource = new MatTableDataSource([]);
    }

    ngOnInit(): void {
        this.loading = true;
        this.repReportS.list().subscribe(res => {
            if (res.message === 'OK') {
                this.loading = false;
                this.dataSource = new MatTableDataSource<any>(res.object);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            } else {
                this.alertS.open(res.message, 'error');
            }
        }, err => {
            this.alertS.open(err.message, 'error');
        });
    }
    filter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    edit(value: number) {
        const dialogRef = this.dialog.open(ReportEditComponent, {
            data: { reportId: value }
        });
        dialogRef.afterClosed().subscribe(res => {
            this.repReportS.list().subscribe(res => {
                if (res.message === 'OK') {
                    this.loading = false;
                    this.dataSource = new MatTableDataSource<any>(res.object);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                } else {
                    this.alertS.open(res.message, 'error');
                }
            }, err => {
                this.alertS.open(err.message, 'error');
            });
        }, err => {
            this.alertS.open(err.message, 'error');
        });
    }
    delete(value: number) {
        this.dialog.open(ConfirmationComponent,{
            data:{message:'¿ Desea eliminar el reporte ?'},
            height:'250px',
            width:'400px'
        }).afterClosed().subscribe(res => {
            if (res) {
                this.repReportS.delete(value).subscribe(res => {
                    if (res.message === 'OK') {
                        if (res.object != 0) {
                            this.alertS.open('Reporte eliminado!', 'success');
                            this.repReportS.list().subscribe(res => {
                                this.loading = false;
                                this.dataSource = new MatTableDataSource<any>(res.object);
                                this.dataSource.paginator = this.paginator;
                                this.dataSource.sort = this.sort;
                            }, err => {
                                this.alertS.open(err, 'error');
                            });
                        } else {
                            this.alertS.open(res.message, 'error');
                        }
                    } else {
                        this.alertS.open(res.message, 'error');
                    }
                }, err => {
                    this.alertS.open(err.message, 'error');
                });
            }
        }, err => {
            this.alertS.open(err.message, 'error');
        });
    }
    getField(value: number) {
        this.dialog.open(FieldModal, {
            data: { 'reportId': value },
            width: '600px'
        });
    }
    getFilter(value: number) {
        this.dialog.open(FilterModal, {
            data: { 'reportId': value },
            width: '600px'
        });
    }

    getCountry(value: number) {
        this.dialog.open(CountryReportModal, {
            data: { 'reportId': value },
            width: '600px'
        });
    }
}